// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LzRZ","footer":"styles_footer__2x7Zu"};